import ActionTypes from '@ziynx/action-types';
import { formatPaginatedResults, getActionGroup } from '@ziynx/components/utilities';

const initialState = {
  GET_LOCATION_API: {
    results: [],
    fetching: false,
    error: null,
  },
  GET_JOB_LOCATION_API: {
    results: [],
    fetching: false,
    error: null,
  },
  GET_INTERESTS_API: {
    results: [],
    fetching: false,
    error: null,
  },
  GET_GRADUATION_YEARS_API: {
    results: [],
    fetching: false,
    error: null,
  },
  GET_COLLEGE_LEAGUE_API: {
    results: [],
    fetching: false,
    error: null,
  },
  GET_CHARACTER_TRAITS_API: {
    results: [],
    fetching: false,
    error: null,
  },
  GET_COMPANIES_API: {
    results: [],
    fetching: false,
    loading: true,
    error: null,
  },
  GET_COMPANY_QUESTIONS_API: {
    results: [],
    fetching: false,
    loading: true,
    error: null,
  },

};

export default function reduceSearch(state = initialState, action) {
  if (!action?.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  switch (action?.type) {
  case ActionTypes.search.getJobLocation.START:
  case ActionTypes.search.getGraduationYears.START:
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: true,
        error: null,
      },
    };

  case ActionTypes.search.getLocation.START:
    return {
      ...state,

      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: false,
        paginating: true,
        error: null,
      },
    };

  case ActionTypes.search.getCharacterTraits.START:
    if (state?.GET_CHARACTER_TRAITS_API?.page >= 0) {
      return {
        ...state,

        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          paginating: true,
          error: null,
        },
      };
    }
    return {
      ...state,

      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: true,
        paginating: false,
        error: null,
      },
    };

  case ActionTypes.search.getInterests.START:
    if (state?.GET_INTERESTS_API?.page >= 0) {
      return {
        ...state,

        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          paginating: true,
          error: null,
        },
      };
    }
    return {
      ...state,

      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: true,
        paginating: false,
        error: null,
      },
    };

  case ActionTypes.search.getCollegeLeague.START:
    if (state?.GET_COLLEGE_LEAGUE_API?.page >= 0) {
      return {
        ...state,

        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          paginating: true,
          error: null,
        },
      };
    }
    return {
      ...state,

      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: true,
        paginating: false,
        error: null,
      },
    };
  case ActionTypes.search.getInterests.SUCCESS:
  case ActionTypes.search.getCollegeLeague.SUCCESS:
  case ActionTypes.search.getLocation.SUCCESS:
  case ActionTypes.search.getJobLocation.SUCCESS:
  case ActionTypes.search.getCharacterTraits.SUCCESS: {
    const data = action?.response;
    const paginatedResults = formatPaginatedResults(
      state[actionGroup],
      action?.response,
    );
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        ...(action?.response ?? {}),
        results: paginatedResults,
        page: data?.page,
        fetching: false,
        paginating: false,
        error: null,
      },
    };
  }

  case ActionTypes.search.getGraduationYears.SUCCESS: {
    const data = action?.response;
    const paginatedResults = formatPaginatedResults(
      state[actionGroup],
      action?.response,
    ).map((item) => (typeof item === 'number' ? item.toString() : item));

    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        ...(action?.response ?? {}),
        results: paginatedResults,
        page: data?.page,
        fetching: false,
        error: null,
      },
    };
  }

  case ActionTypes.search.getInterests.ERROR:
  case ActionTypes.search.getCollegeLeague.ERROR:
  case ActionTypes.search.getGraduationYears.ERROR:
  case ActionTypes.search.getLocation.ERROR:
  case ActionTypes.search.getJobLocation.ERROR:
  case ActionTypes.search.getCharacterTraits.ERROR:
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: false,
        paginating: false,
        error: action?.error,
      },
    };
  case ActionTypes.search.getCompanies.START:
    if (state?.GET_COMPANIES_API?.page >= 0
      || state?.GET_COMPANIES_API?.page === undefined) {
      return {
        ...state,

        [actionGroup]: {
          ...(state[actionGroup] || {}),
          fetching: false,
          paginating: true,
          error: null,
        },
      };
    }
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: true,
        paginating: false,
        loading: true,
        error: null,
      },
    };
  case ActionTypes.search.getCompanyQuestions.START:
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: !action?.searching && !action?.paginating,
        searching: action?.searching,
        paginating: action?.paginating,
        error: null,
      },
    };
  case ActionTypes.search.getCompanyQuestions.SUCCESS:
  case ActionTypes.search.getCompanies.SUCCESS: {
    const data = action?.response;
    const paginatedResults = formatPaginatedResults(
      state[actionGroup],
      action?.response,
    );
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        ...(action?.response ?? {}),
        results: paginatedResults,
        page: data.page,
        fetching: false,
        searching: false,
        paginating: false,
        loading: false,
        error: null,
      },
    };
  }
  case ActionTypes.search.getCompanyQuestions.ERROR:
  case ActionTypes.search.getCompanies.ERROR:
    return {
      ...state,
      [actionGroup]: {
        ...(state[actionGroup] || {}),
        fetching: false,
        searching: false,
        paginating: false,
        loading: false,
        error: action?.error,
      },
    };
  default:
    return state;
  }
}
